document.addEventListener('DOMContentLoaded', function () {
	//Accordion JS
	var acc = document.getElementsByClassName("course-accordion");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].onclick = function () {
			var panel = this.nextElementSibling;
			var coursePanel = document.getElementsByClassName("course-panel");
			var courseAccordion = document.getElementsByClassName("course-accordion");
			var courseAccordionActive = document.getElementsByClassName("course-accordion active");

			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
				this.classList.remove("active");
			} else {
				for (var ii = 0; ii < courseAccordionActive.length; ii++) {
					courseAccordionActive[ii].classList.remove("active");
				}
				for (var iii = 0; iii < coursePanel.length; iii++) {
					this.classList.remove("active");
					coursePanel[iii].style.maxHeight = null;
				}
				panel.style.maxHeight = panel.scrollHeight + "px";
				this.classList.add("active");
			}
		}
	}


// the below js is used to hide a class when close is clicked
	// Guard: sin la barra countdown en la página, el null rompía el resto del archivo
	if (document.querySelector(".close_arrow") && document.querySelector(".close_arrow button")) {
		document.querySelector(".close_arrow").querySelector("button").addEventListener("click", closeFunction);
	}

	function closeFunction() {
		document.body.classList.add('countdown-closed');
		document.documentElement.style.setProperty('--countdown-bar-height', `0px`);
		document.querySelector(".countdown-condensed").style.display = "none";
	}


// The below js is used to click humberger Menu
	if (document.querySelectorAll(".header_hamburger").length) {
		document.querySelectorAll(".header_hamburger").forEach(function (element) {
			element.addEventListener("click", addClass);
		});
	}

	function addClass() {
		document.body.classList.add('open-menu');
		let sidePanelelement = document.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist');
		sidePanelelement.forEach(function (ele) {
			if (sessionStorage.getItem("nav-title")) {
				let getTitle = sessionStorage.getItem("nav-title")
				if (ele.querySelector(`li [data-link="${getTitle}"]`)) {
					ele.querySelector(`li [data-link="${getTitle}"]`).click();
				}
				setTimeout(function () {
					sessionStorage.removeItem("nav-title");
				}, 800);
			} else {
				ele.querySelector('li button').click();
			}

			if (ele.querySelector('li [aria-current="page"]')) {
				ele.querySelector('li [aria-current="page"]').click();
			}

		});

		// Helper to position a single submenu
		function updateSubmenuPosition(Ele) {
			const nestedList = Ele.querySelector('.header-sidebar__nested-linklist');
			const detailsItem = Ele.querySelector('details');
			if (nestedList && detailsItem && detailsItem.hasAttribute('open')) {
				const parentTop = Ele.offsetTop;							
				const scroller = Ele.closest('.header-sidebar__scroller');							
				const scrollerHeight = scroller.offsetHeight;
				const submenuHeight = nestedList.offsetHeight || 300; 
				nestedList.style.bottom = 'auto';
				
				if (parentTop + submenuHeight > scrollerHeight) {
					let topPos = Math.max(0, scrollerHeight - submenuHeight - 20);
					nestedList.style.top = `${topPos}px`;
				} else {
					nestedList.style.top = `${parentTop}px`;
				}
				
				// Clear the min-height adjustment as we are using horizontal flyout
				scroller.style.minHeight = '';
			}
		}

		// Initial initialization for any pre-opened items
		setTimeout(function() {
			if (document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').length) {
				document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel .header-sidebar__linklist li').forEach(function(El) {
					if (El.querySelector('details') && El.querySelector('details').hasAttribute('open')) {
						updateSubmenuPosition(El);
					}
				});
			}
		}, 100);

		//On Hover Event For Sidebar Navigation
		if (document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').length) {
			document.querySelectorAll('#sidebar-menu .header-sidebar__sub-panel').forEach(function (element) {
				element.querySelectorAll('.header-sidebar__linklist li').forEach(function (Element) {

					Element.addEventListener('mouseenter', function (Ele) {
						// First handle open state so we can calculate proper layout
						element.querySelectorAll('.header-sidebar__linklist li').forEach(function (El) {
							El.classList.remove('currentActive');
							if (El.querySelector('details')) {
								El.querySelector('details').removeAttribute('open');
							}
						})
						if (Ele.currentTarget.querySelector('details')) {
							Ele.currentTarget.classList.add('currentActive');
							Ele.currentTarget.querySelector('details').setAttribute('open', true);
						}

						// Now positioned correctly
						updateSubmenuPosition(Ele.currentTarget);
					})
				})
			});
		}

	}

//Slide Homepage slider on click Menu
	function findMainSliderByNavTitle(navTitle) {
		return Array.from(document.querySelectorAll('.main-slider')).find(function (slider) {
			return slider.dataset.navTitle === navTitle;
		});
	}

	function syncSidebarPanel(sidebar, navTitle) {
		if (!sidebar || !navTitle) return;

		let panelTrigger = Array.from(sidebar.querySelectorAll('.header-sidebar__main-panel [data-link][aria-controls]')).find(function (button) {
			return button.dataset.link === navTitle;
		});

		if (!panelTrigger) return;

		panelTrigger.click();
	}

	function openHeaderMenuForNavTitle(navTitle) {
		let sidebarId = window.matchMedia('(max-width: 999px)').matches ? 'sidebar-menu-mobile' : 'sidebar-menu';
		let sidebar = document.getElementById(sidebarId);
		if (!sidebar) return;

		let openButton = document.querySelector(`.header_hamburger[aria-controls="${sidebarId}"]`);

		if (sidebar.hasAttribute('open')) {
			syncSidebarPanel(sidebar, navTitle);
			return;
		}

		sidebar.addEventListener('dialog:after-show', function () {
			syncSidebarPanel(sidebar, navTitle);
		}, { once: true });

		if (openButton) {
			openButton.click();
		} else if (typeof sidebar.show === 'function') {
			document.body.classList.add('open-menu');
			sidebar.show();
		}
	}

	if (document.querySelector('.header__primary-nav')) {
		document.querySelectorAll('.header__primary-nav .header__primary-nav-item').forEach(function (ele) {
			ele.addEventListener('click', function (Element) {
				let getTitle = Element.currentTarget.getAttribute('data-title');
				let hasSliderNavigation = document.querySelector('.main-slider[data-nav-title]');
				let targetSlide = findMainSliderByNavTitle(getTitle);

				if (!getTitle || !hasSliderNavigation) return;

				Element.preventDefault();

				if (targetSlide) {
					let swiperMain = document.querySelector(".swiper_main");
					if (swiperMain && swiperMain.swiper) {
						swiperMain.swiper.slides.forEach((slide, index) => {
							let slideMainSlider = slide.querySelector('.main-slider');
							if (slideMainSlider && slideMainSlider.dataset.navTitle == getTitle) {
								swiperMain.swiper.slideTo(index);
							}
						});
					}
				}

				sessionStorage.setItem("nav-title", getTitle);
				openHeaderMenuForNavTitle(getTitle);
			})
		});
	}


//Drawer Close After Click on continue shopping Btn
	window.continueShopingBtn = function continueShopingBtn() {
		if (document.querySelectorAll('.js-continue-shoping').length) {
			document.querySelector("#cart-drawer").shadowRoot.querySelector("button").click();
		}
	}


// Clear All Filter Event In Drawer, excepto disponibilidad
window.facetClear = function facetClear() {
    if (document.querySelector('.js-facets-cart-clear')) {
        document.querySelector('.js-facets-cart-clear').addEventListener('click', function () {
            // Simular el clic para borrar todos los filtros
            if (document.querySelector(".collection__main")) {
                const clearAllButton = document.querySelector(".collection__main").querySelector('.active-facets .facets-clear-all');
                if (clearAllButton) {
                    clearAllButton.click(); // Borrar todos los filtros
                }

                // Mantener el filtro de disponibilidad activado
                const availabilityFilter = document.querySelector("input[name='filter.v.availability'][value='1']");
                if (availabilityFilter) {
                    availabilityFilter.checked = true; // Asegurarse de que el filtro de disponibilidad siga marcado
                }
            }

            // Crear una nueva URL con el filtro de disponibilidad
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Asegurarse de que el filtro de disponibilidad esté en la URL
            params.set('filter.v.availability', '1');

            // Actualizar la URL y recargar la página con el filtro de disponibilidad activo
            window.location.href = `${url.pathname}?${params.toString()}`;
        });
    }
};

window.facetClear();

/* Shop the look: flechas de producto (Javier 09-10-2026)

   Antes esto cogia los dots de TODA la pagina en una sola lista
   (querySelectorAll sin acotar) y llevaba un unico indice global, con
   las flechas del primer bloque del documento. En el desfile, que tiene
   diez miradas, al llegar al tercer producto el indice seguia subiendo
   hasta el dot del bloque siguiente: la flecha parecia no hacer nada y
   luego habia que pulsar atras tantas veces como clics de mas se habian
   dado para que volviera a moverse.

   Ahora cada mirada maneja SUS dots y SUS flechas, y el indice no se
   guarda: se lee del dot que este marcado en ese momento, asi que no se
   desincroniza si el cliente usa los puntos de la foto o los dots. */
	document.querySelectorAll('.shop-the-look__item-content').forEach(function (bloque) {
		var dots = bloque.querySelectorAll('.page-dots .tap-area');
		var prevButton = bloque.querySelector('.js-prev');
		var nextButton = bloque.querySelector('.js-next');
		if (!dots.length || !prevButton || !nextButton) return;

		function indiceActual() {
			for (var i = 0; i < dots.length; i++) {
				if (dots[i].getAttribute('aria-current') === 'true') return i;
			}
			return 0;
		}

		function pinta() {
			var i = indiceActual();
			prevButton.toggleAttribute('disabled', i === 0);
			nextButton.toggleAttribute('disabled', i === dots.length - 1);
		}

		function mueve(paso) {
			var i = indiceActual();
			var destino = i + paso;
			if (destino < 0 || destino > dots.length - 1) return;
			dots[i].setAttribute('aria-current', 'false');
			dots[destino].setAttribute('aria-current', 'true');
			dots[destino].click();
			pinta();
		}

		prevButton.addEventListener('click', function () { mueve(-1); });
		nextButton.addEventListener('click', function () { mueve(1); });
		/* los puntos de la foto y los dots tambien mueven el carrusel:
		   se repasa el estado de las flechas cuando cambian */
		dots.forEach(function (d) { d.addEventListener('click', function () { setTimeout(pinta, 0); }); });
		var hotspots = bloque.closest('.shop-the-look__item');
		hotspots = hotspots ? hotspots.querySelectorAll('.shop-the-look__hot-spot') : [];
		hotspots.forEach(function (h) { h.addEventListener('click', function () { setTimeout(pinta, 0); }); });

		pinta();
	});

	var tabLinks = document.querySelectorAll(".js-faq-btn");
	var tabContent = document.querySelectorAll(".faq__category_title");

	tabLinks.forEach(function (el) {
		el.addEventListener("click", openTabs);
	});

	function openTabs(el) {
		var btnTarget = el.currentTarget;
		let getId = btnTarget.getAttribute('data-block-id');
		let click_heading = document.querySelector(`[id="${getId}"]`);
		tabContent.forEach(function (el) {
			el.classList.remove("tab-active");
		});

		tabLinks.forEach(function (el) {
			el.classList.remove("is-active");
		});

		click_heading.classList.add("tab-active");
		btnTarget.classList.add("is-active");
	}


//HIDE SHOW PASSWORD ON EYE CLICK
	if (document.querySelectorAll('.show_password').length && document.querySelectorAll('.hide_password').length) {
		document.querySelectorAll('.show_password').forEach(function (ele) {
			ele.addEventListener('click', function (element) {
				element.currentTarget.classList.add('hidden');
				element.currentTarget.closest('.form-control').querySelector('.hide_password').classList.remove('hidden');
				let password = element.currentTarget.closest('.form-control').querySelector(`input`),
					type = password.getAttribute("type") === "password" ? "text" : "password";
				password.setAttribute("type", type);
			});
		});

		document.querySelectorAll('.hide_password').forEach(function (ele) {
			ele.addEventListener('click', function (element) {
				element.currentTarget.classList.add('hidden')
				element.currentTarget.closest('.form-control').querySelector('.show_password').classList.remove('hidden');
				let password = element.currentTarget.closest('.form-control').querySelector(`input`),
					type = password.getAttribute("type") === "password" ? "text" : "password";
				password.setAttribute("type", type);
			});
		});
	}


//Contact page Validation JS
	let contactFormId = document.querySelector('#contact_form');
	if (contactFormId) {
		contactFormId.querySelector('button').addEventListener('click', function (element) {
			document.getElementById('nameError').innerText = '';
			document.getElementById('emailError').innerText = '';
			document.getElementById('consultationError').innerText = '';
			document.getElementById('conceptError').innerText = '';

			let name = contactFormId.querySelector('[name="contact[name]"]').value.trim();
			let email = contactFormId.querySelector('[name="contact[email]"]').value.trim();
			let consultation = contactFormId.querySelector('[name="contact[body]"]').value.trim();

			if (name === '') {
				document.getElementById('nameError').innerText = 'se requiere nombre y apellido';
				return false;
			}

			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(email)) {
				document.getElementById('emailError').innerText = 'Dirección de correo electrónico no válida';
				return false;
			}

			if (document.querySelector("#mounth").value === '') {
				document.getElementById('conceptError').innerText = 'se requiere concepto';
				return false;
			}

			if (consultation === '') {
				document.getElementById('consultationError').innerText = 'Se requiere consulta';
				return false;
			}
			document.querySelector('#contact_form').submit();
			return true;
		});
	}


//Foundation page Slider And Events
	if (document.querySelector('.year-slider')) {
		new Flickity(document.querySelector('.year-slider'), {
            accessibiility: false,
			cellAlign: "left",
			contain: true,
			wrapAround: false,
			prevNextButtons: true,
			pauseAutoPlayOnHover: false,
			pageDots: false,
			draggable: true
		});
	}

	let foundationYearWrap = document.querySelector('.foundation-main-wrap'),
		foundationContentWrap = document.querySelector('.js-foundation-content-wrap');
	if (foundationYearWrap) {
		foundationYearWrap.querySelectorAll('.js-timeline-date-btn').forEach(function (Element) {
			Element.addEventListener('click', function (ele) {
				foundationYearWrap.querySelectorAll('.js-timeline-date-btn').forEach(function (element) {
					element.classList.remove('is-active');
				});
				ele.currentTarget.classList.add('is-active');

				let getYear = ele.currentTarget.getAttribute('data-year');
				foundationContentWrap.querySelectorAll('.text-component').forEach(function (contentElement) {
					if (contentElement.getAttribute('data-year') === getYear) {
						contentElement.classList.remove('hidden');
					} else {
						contentElement.classList.add('hidden');
					}
				});
			});
		});
	}

	//Register Page Silbon People Checkbox
	let PeopleCheckobox = document.getElementById('customer_tags');
	if (PeopleCheckobox) {
		PeopleCheckobox.addEventListener('change', (event) => {
			if (event.currentTarget.checked) {
				event.currentTarget.value = "SilbonPeople";
			} else {
				event.currentTarget.value = '';
			}
		});
	}


	
	
	


// side bar menu dragable //
	let mouseDown = false;
	let startX, scrollLeft;
	const slider = document.querySelector('.header-sidebar__scroller');

	const startDragging = (e) => {
		mouseDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	}

	const stopDragging = (e) => {
		mouseDown = false;
	}

	const move = (e) => {
		e.preventDefault();
		if (!mouseDown) {
			return;
		}
		const x = e.pageX - slider.offsetLeft;
		const scroll = x - startX;
		slider.scrollLeft = scrollLeft - scroll;
	}

// Add the event listeners
	slider.addEventListener('mousemove', move, false);
	slider.addEventListener('mousedown', startDragging, false);
	slider.addEventListener('mouseup', stopDragging, false);
	slider.addEventListener('mouseleave', stopDragging, false);
});
const openDrawerBtn = document.getElementById('openDrawerBtn');
document.addEventListener('DOMContentLoaded', function () {
	const openDrawerBtn = document.getElementById('openDrawerBtn');
	const closeDrawerBtn = document.getElementById('closeDrawerBtn');
	const drawer = document.getElementById('drawer');
	const overlay = document.getElementById('overlay');

	document.querySelectorAll('[id="openDrawerBtn"]').forEach(btn => {
		btn.addEventListener('click', () => {
			drawer.classList.add('opened');
			overlay.classList.add('opened');
			document.body.classList.add('drawer-opened');
			setTimeout(() => {
				if (drawer.classList.contains('opened')) {
					document.getElementById('customer_email')?.focus();
				}
			}, 350);
		});
	});

	if (closeDrawerBtn) {
		closeDrawerBtn.addEventListener('click', () => {
			closeDrawer();
		});
	}

	if (overlay) {
		overlay.addEventListener('click', () => {
			closeDrawer();
		});
	}

	function closeDrawer() {
		drawer.classList.remove('opened');
		overlay.classList.remove('opened');
		document.body.classList.remove('drawer-opened'); // Remove class from body
	}

	function toggleDrawer() {
		var body = document.querySelector("body");
		var overlay = document.getElementById("drawer_customer_registrate_main_overlay");
		var hasClass = body.classList.contains("drawer_customer_registrate_main");

		if (!hasClass) {
			body.classList.add("drawer_customer_registrate_main"); // Add the specified class to body
		} else {
			body.classList.remove("drawer_customer_registrate_main"); // Remove the specified class from body
		}
	}

	window.addEventListener('scroll', function () {
		let stickyHeaderOffset = parseFloat(document.querySelector('html').style.getPropertyValue('--header-height'));

		let checkElementInView = function (element) {
			if (element) {
				let elementOffsetTop = parseFloat(element.offsetTop),
					elementHeight = parseFloat(element.offsetHeight),
					windowHeight = window.innerHeight,
					scrollTop = window.scrollY;

				return scrollTop + windowHeight > elementOffsetTop && scrollTop < elementOffsetTop + elementHeight;
			}
			return false;
		};

		let newsletterElement = document.querySelector('.shopify-section-group-footer-group');
		let iconWithHorizontalElement = document.querySelector('.icon_with_horizontal');
		let footerElement = document.querySelector('.footer');

		let isNewsletterInView = checkElementInView(newsletterElement);
		let isIconWithHorizontalInView = checkElementInView(iconWithHorizontalElement);
		let isFooterInView = checkElementInView(footerElement);

		// if (isNewsletterInView || isIconWithHorizontalInView || isFooterInView) {
		// 	document.body.classList.add('header_not_sticky');
		// } else {
		// 	document.body.classList.remove('header_not_sticky');
		// }
	});

	document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
	if (Shopify.designMode) {
		document.documentElement.classList.add('shopify-design-mode');
	}
	document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
	document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');

	var initialWidth = window.visualViewport.width;
	window.addEventListener('resize', function () {
		var newWidth = window.visualViewport.width;
		if (newWidth !== initialWidth) {
			document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
			document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');
		}
	});

	function getBroswerDetails() {
		//Checking the user's OS and Browser
		if ((navigator.userAgent).includes("Android")) {
			document.querySelector("html").classList.add("android");
		} else if ((navigator.userAgent).includes("Mac")) {
			document.querySelector("html").classList.add("mac");
		} else {
			document.querySelector("html").classList.add("windows");
		}


		//-- Browser --//
		var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		var isFirefox = typeof InstallTrigger !== 'undefined';
		var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		})(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
		var isIE = /*@cc_on!@*/ false || !!document.documentMode;
		var isEdge = !isIE && !!window.StyleMedia;
		var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
		var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
		var isBlink = (isChrome || isOpera) && !!window.CSS;
		if (isFirefox) {
			document.querySelector("html").classList.add("isFirefox")
		} else if (isChrome) {
			document.querySelector("html").classList.add("isChrome")
		} else if (isSafari) {
			document.querySelector("html").classList.add("isSafari")
		} else if (isOpera) {
			document.querySelector("html").classList.add("isOpera")
		} else if (isIE) {
			document.querySelector("html").classList.add("isIE")
		} else if (isEdge) {
			document.querySelector("html").classList.add("isEdge")
		} else if (isEdgeChromium) {
			document.querySelector("html").classList.add("isEdgeChromium")
		} else {
			document.querySelector("html").classList.add("isBlink")
		}
	}

	getBroswerDetails();

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		// true for mobile device
		document.querySelector("html").classList.add("mobile");
	}
});

/* Bloqueo del scroll de fondo con el drawer de login/registro abierto.
   En iOS el overflow:hidden del body/html no impide que el dedo arrastre la
   página (sobre todo sobre el hero, y sobre el velo oscuro). Se frenan los
   touchmove que no son de dentro del panel, y dentro del panel solo se dejan
   pasar si hay algo que desplazar en esa dirección (así no se encadena al
   fondo al llegar al final). No se usa body{position:fixed} porque llevaría
   scrollY a 0 y la cabecera cambiaría de estado (todo va por posición). */
(function () {
	var lastY = 0;
	function locked() {
		var c = document.body.classList;
		return c.contains('drawer-opened') || c.contains('drawer_customer_registrate_main');
	}
	function scroller(el, panel) {
		while (el && el !== panel.parentNode) {
			if (el.scrollHeight > el.clientHeight + 1) {
				var oy = getComputedStyle(el).overflowY;
				if (oy === 'auto' || oy === 'scroll') return el;
			}
			el = el.parentNode;
		}
		return null;
	}
	document.addEventListener('touchstart', function (e) {
		lastY = e.touches[0].clientY;
	}, { passive: true });
	document.addEventListener('touchmove', function (e) {
		if (!locked() || e.touches.length > 1) return;
		var y = e.touches[0].clientY;
		var dy = y - lastY;
		lastY = y;
		var panel = e.target.closest && e.target.closest('.custom_drawer_account');
		if (!panel) { e.preventDefault(); return; }
		var s = scroller(e.target, panel);
		if (!s) { e.preventDefault(); return; }
		var atTop = s.scrollTop <= 0;
		var atBottom = s.scrollTop + s.clientHeight >= s.scrollHeight - 1;
		if ((dy > 0 && atTop) || (dy < 0 && atBottom)) e.preventDefault();
	}, { passive: false });
	document.addEventListener('wheel', function (e) {
		if (locked() && !(e.target.closest && e.target.closest('.custom_drawer_account'))) e.preventDefault();
	}, { passive: false });
})();

/* Segundo cinturón del bloqueo (Javier 2026-10-01: el filtro de touchmove
   solo no bastaba en el móvil): al abrir el drawer se congela el body con
   position:fixed y se restaura el scroll exacto al cerrar. Es lo único que
   iOS respeta de verdad. Con el drawer a pantalla completa en móvil, que la
   cabecera vea scrollY=0 mientras está abierto no se nota; al cerrar se
   devuelve el scroll y vuelve a su estado. */
(function () {
	var savedY = null;
	function isOpen() {
		var c = document.body.classList;
		return c.contains('drawer-opened') || c.contains('drawer_customer_registrate_main');
	}
	function sync() {
		var b = document.body;
		if (isOpen() && savedY === null) {
			savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
			b.style.position = 'fixed';
			b.style.top = '-' + savedY + 'px';
			b.style.left = '0';
			b.style.right = '0';
			b.style.width = '100%';
		} else if (!isOpen() && savedY !== null) {
			var y = savedY;
			savedY = null;
			b.style.position = '';
			b.style.top = '';
			b.style.left = '';
			b.style.right = '';
			b.style.width = '';
			window.scrollTo({ top: y, left: 0, behavior: 'instant' });
		}
	}
	new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
	sync();
})();
